"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFile = exports.isDirectory = exports.DIRECTORY_TYPE = void 0;
/**
 * Constant for directory Mime-Type.
 * Value: `inode/directory`
 */
exports.DIRECTORY_TYPE = 'inode/directory';
const isDirectory = (node) => node.type === exports.DIRECTORY_TYPE;
exports.isDirectory = isDirectory;
const isFile = (node) => node.type !== exports.DIRECTORY_TYPE;
exports.isFile = isFile;
//# sourceMappingURL=ProjectFile.js.map